import * as React from "react";

export type EmptyStateProps = React.HTMLAttributes<HTMLDivElement> & {
  icon?: React.ReactNode;
  title: string;
  description?: React.ReactNode;
  action?: React.ReactNode;
};

export const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ className = "", icon, title, description, action, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`rounded-3xl border border-dashed border-neutral-200 bg-white px-8 py-10 text-center ${className}`}
        {...props}
      >
        {icon && <div className="mx-auto mb-4 text-neutral-400">{icon}</div>}
        <h3 className="text-2xl font-semibold text-neutral-900">{title}</h3>
        {description && <p className="mt-2 text-sm text-neutral-500">{description}</p>}
        {action && <div className="mt-6">{action}</div>}
      </div>
    );
  }
);

EmptyState.displayName = "EmptyState";
